// 用户设置相关API接口
import apiClient, { API_ENDPOINTS } from "@/config/api";

/**
 * 用户设置API类
 */
export class UserSettingsAPI {
  /**
   * 获取用户设置
   * @param {string} category - 设置分类（可选）
   * @returns {Promise<Object>} 用户设置数据
   */
  static async getUserSettings(category = '') {
    try {
      const params = category ? { category } : {};
      const response = await apiClient.get(API_ENDPOINTS.USER_SETTINGS.GET, { params });
      
      console.log('用户设置API响应:', response);
      
      // API拦截器已经处理了响应，直接返回成功格式
      return {
        success: true,
        data: response,
        message: '获取用户设置成功'
      };
    } catch (error) {
      console.error('获取用户设置失败：', error);
      return {
        success: false,
        data: null,
        message: error.apiResponse?.msg || error.message || '网络错误'
      };
    }
  }

  /**
   * 更新用户设置
   * @param {Array} settings - 设置数组
   * @returns {Promise<Object>} 更新结果
   */
  static async updateUserSettings(settings) {
    try {
      await apiClient.post(API_ENDPOINTS.USER_SETTINGS.UPDATE, {
        settings
      });
      
      return {
        success: true,
        message: '更新设置成功'
      };
    } catch (error) {
      console.error('更新用户设置失败：', error);
      return {
        success: false,
        message: error.apiResponse?.msg || error.message || '网络错误'
      };
    }
  }

  /**
   * 重置设置到默认值
   * @param {string} category - 设置分类（可选）
   * @returns {Promise<Object>} 重置结果
   */
  static async resetToDefault(category = '') {
    try {
      await apiClient.post(API_ENDPOINTS.USER_SETTINGS.RESET, {
        category
      });
      
      return {
        success: true,
        message: '重置设置成功'
      };
    } catch (error) {
      console.error('重置设置失败：', error);
      return {
        success: false,
        message: error.apiResponse?.msg || error.message || '网络错误'
      };
    }
  }
}

export default UserSettingsAPI;

/**
 * 为兼容已有代码中 `import { userSettingsApi } from '@/api/userSettings'` 的写法，
 * 这里提供一个具名导出 userSettingsApi ，包装现有 UserSettingsAPI 静态方法。
 * 同时补充一个 updateUserSetting 单项更新便捷函数（内部复用批量接口或后续单独实现）。
 */
export const userSettingsApi = {
  getUserSettings: async (category = '') => {
    // 复用现有实现
    const res = await UserSettingsAPI.getUserSettings(category);
    // 与 backgroundMusicManager 期望的“数组/对象列表”保持兼容：
    // 目前 UserSettingsAPI 返回 { success, data, message }
    return res.data || {};
  },
  updateUserSettings: UserSettingsAPI.updateUserSettings,
  resetToDefault: UserSettingsAPI.resetToDefault,
  /**
   * 更新单项设置的便捷方法。
   * 如果后端已有单项更新接口可改为直接调用；当前临时将其包装成批量更新。
   * @param {string} key
   * @param {any} value
   */
  updateUserSetting: async (key, value) => {
    try {
      const payload = [
        {
          key,
          value,
        },
      ];
      return await UserSettingsAPI.updateUserSettings(payload);
    } catch (e) {
      return { success: false, message: e.message || '更新单项设置失败' };
    }
  },
};
